import numeral from 'numeral';
import {BaseNumberValueConverter} from "./base-number";

/**
 * Format numbers values according to format using numeral.
 *
 * Default: decimal with 2 digits
 */
export class NumberValueConverter extends BaseNumberValueConverter {

}
